
import { mapMutations } from 'vuex'
import Interval from '@derpierre65/vue-utils/src/mixins/Interval'

export default {
  name: 'SaleBanner',
  mixins: [Interval],
  data () {
    const date = new Date()
    date.setHours(24, 0, 0, 0)

    return {
      midnightDate: date,
      couponCode: process.env.COUPON_CODE,
      percent: process.env.COUPON_PERCENT,
      remaining: {}
    }
  },
  mounted () {
    this.setInterval(this.updateRemaining, 800, 'updateTimer', true)
  },
  methods: {
    ...mapMutations({
      closeSaleBanner: 'salebanner/hide'
    }),
    updateRemaining () {
      let rest = (this.midnightDate.getTime() - Date.now()) / 1000

      if (rest < 0) {
        this.midnightDate = new Date()
        this.midnightDate.setHours(24, 0, 0, 0)
      }

      const hours = Math.floor(rest / 3600)
      rest = rest - (hours * 3600)
      const minutes = Math.floor(rest / 60)
      rest = rest - (minutes * 60)
      const seconds = Math.floor(rest)

      this.remaining = {
        hours: ('0' + hours).slice(-2),
        minutes: ('0' + minutes).slice(-2),
        seconds: ('0' + seconds).slice(-2)
      }
    }
  }
}
